import api from "../lib/api.ts";

interface CorporateBuyerParams {
    page?: number;
    limit?: number;
    search?: string;
}



export const createCorporateBuyer = async (userData: FormData) => {
    const response = await api.post("/users/create/buyerforcoorporate", userData, {
        timeout: 70000,
    });
    return response.data;
};

export const updateCorporateBuyer = async (userId: number, userData: FormData) => {
    const response = await api.put(`/users/edit/${userId}`, userData, {
        timeout: 70000,
    });
    return response.data;
};

export const getCorporateBuyerById = async (id: string | number) => {
    const response = await api.get(`/users/corporatebuyer/${id}`);
    return response.data;
};

// Get all corporate buyers with pagination
export const getCorporateBuyers = async (params: CorporateBuyerParams = {}) => {
    try {
        const safeParams = params || {};
        const response = await api.get("users/corporatebuyers", { params: safeParams });
        return response.data;
    } catch (error) {
        console.error("Error fetching corporate buyers:", error);
        throw error;
    }
};


export const deleteCorporateBuyer = async (buyerId: number) => {
    try {
        const response = await api.delete(`users/deletebuyerforoperate/${buyerId}`);
        return response.data;
    } catch (error) {
        console.error("Error deleting corporate buyer:", error);
        throw error;
    }
};

export const getParentBuyerLimits= async (buyerId:number)=>{
    try {
        const response = await api.get(`buyerpackagehistories/buyer/${buyerId}`);
        return response.data;
    } catch (error) {
        console.error("Error deleting corporate buyer:", error);
        throw error;
    }

}